import type { PlatformAdapter } from "./PlatformAdapter";
import { localPlatform } from "./LocalPlatform";
import { serverPlatform } from "./ServerPlatform";

// Local remains the default in every environment (dev, test, and production
// builds without an explicit override) so nothing changes for game
// development/testing until a build opts into server mode.
const mode = import.meta.env.VITE_ARCTREE_PLATFORM ?? "local";

function resolvePlatform(): PlatformAdapter {
  switch (mode) {
    case "local":
      return localPlatform;
    case "server":
      return serverPlatform;
    default:
      throw new Error(`Unknown VITE_ARCTREE_PLATFORM: "${mode}"`);
  }
}

export const platform: PlatformAdapter = resolvePlatform();
export type { PlatformAdapter } from "./PlatformAdapter";
